import { rem } from 'polished';
import styled from 'styled-components';

export const P = styled.p`
  font-size: ${rem(14)};
  margin-top: 0;
  margin-bottom: ${rem(20)};

  .globe {
    margin-right: ${rem(8)};
    vertical-align: text-top;
  }
`;
